import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';

import background from '../assets/img/login-bg.jpg';
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
  backgroundImage: `url(${background})`,
  backgroundRepeat: 'no-repeat',
  top: '0',
  position: 'absolute',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100vh',
  width: '100vw',
  alignItems: 'center',
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  width: '90%',
  margin: 'auto',
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(2, 5, 3, 5),
  backgroundColor: '#ffffffe0',
  // border:'1px solid',
  borderRadius: '10% 10% 10% 10%',
  // marginTop: theme.spacing(6),
}));
const LogoContainer = styled('div')(({ theme }) => ({
  margin: '30px',
  // width: '90%',
  // margin: 'auto',
  // minHeight: '50vh',
  // display: 'flex',
  // justifyContent: 'center',
  // flexDirection: 'column',
  // padding: theme.spacing(5, 5, 3, 5),
  // backgroundColor: '#ffffffe0',
  // marginTop: theme.spacing(6),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title>Immigration System </title>
      </Helmet>

      <StyledRoot>
        {/* {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )} */}

        <Container maxWidth="sm">
          <StyledContent>
            <LogoContainer>
              <Logo />
            </LogoContainer>

            {/* login Form */}
            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
